const STORAGE_KEY = 'derelict-best-times';

interface BestTimes {
  [level: number]: number;  // level -> time in ms
}

function loadBestTimes(): BestTimes {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : {};
  } catch {
    return {};
  }
}

function saveBestTimes(times: BestTimes): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(times));
  } catch {
    // localStorage might be unavailable or full
  }
}

export function getBestTime(level: number): number | null {
  const times = loadBestTimes();
  return times[level] ?? null;
}

// Returns true if this is a new personal best (only if there was a previous time to beat)
export function checkAndSaveBestTime(level: number, timeMs: number): boolean {
  const times = loadBestTimes();
  const previousBest = times[level];

  if (previousBest === undefined) {
    // First completion - save time but don't report as "new best"
    times[level] = timeMs;
    saveBestTimes(times);
    return false;
  }

  if (timeMs < previousBest) {
    // Beat the previous record
    times[level] = timeMs;
    saveBestTimes(times);
    return true;
  }

  return false;
}

// Returns the highest level that has been played (has a recorded time)
export function getHighestPlayedLevel(): number {
  const times = loadBestTimes();
  const levels = Object.keys(times).map(Number);
  return levels.length > 0 ? Math.max(...levels) : 0;
}
